import { useResolvedPath } from 'react-router-dom';
import { Session } from '@app/api';
import { useEditSessionSteps } from '../steps';

export const useCurrentStepIndex = (session: Session) => {
  const { pathname } = useResolvedPath('');
  const { steps } = useEditSessionSteps(session);
  return steps.findIndex((step) => pathname.endsWith(step.path));
};

export const useNextStepPath = (session: Session) => {
  const { steps } = useEditSessionSteps(session);
  const index = useCurrentStepIndex(session);
  const nextIndex = index + 1;
  if (nextIndex === steps.length) {
    return undefined;
  }

  return `../${steps[nextIndex].path}`;
};

export const usePrevStepPath = (session: Session) => {
  const { steps } = useEditSessionSteps(session);
  const index = useCurrentStepIndex(session);
  const prevIndex = index - 1;
  if (prevIndex < 0) {
    return undefined;
  }

  return `../${steps[prevIndex].path}`;
};
